<template>
  <div class="view giftcert">

    <div class="container">
      <h1>{{$t('home.tabs.giftcert')}}</h1>

      <h2>{{ $t('form.label.gift.amount') }}</h2>

      <div class="preset-amount" v-if="enableDenoms">
        <div v-for="denom in denoms" :key="denom">
          <input class="button-amount" type="radio" name="preset-amount" :id="`denom-${denom}`" :value="denom" v-model="cartItem.giftAmount"><label :for="`denom-${denom}`">{{ $formatter.currency(denom) }}</label>
        </div>
      </div>

      <form-input type="number" :label="$t('general.label.amount')" icon="amount" :readonly="!enableCustomAmount" v-model="cartItem.giftAmount"/>

      <h2>{{ $t('form.label.gift.recipient') }}</h2>
      <div class="name-container">
        <form-input type="text" :label="$t('form.label.guest.first-name')" icon="name" v-model="cartItem.giftFirstName"/>
        <form-input type="text" :label="$t('form.label.guest.last-name')" v-model="cartItem.giftLastName"/>
      </div>
      <form-input type="text" :label="$t('form.label.guest.email')" icon="email" v-model="cartItem.giftEmail"/>
      <form-input type="textarea" :label="$t('form.label.gift.message')" icon="message" v-model="cartItem.giftMessage"/>

      <div class="total-price">{{ $t('general.label.total') }}:<span>{{ $formatter.currency(cartItem.giftAmount) }}</span></div>
      <button class="button-add" :class="{ active: buttonActive }" @click="onAddToCart">{{ $t('form.label.add-to-cart') }}</button>

    </div>

  </div>
</template>

<script>

import PortalSettings from '@/models/PortalSettings';
import FormInput from '@/components/FormInput.vue';
import Cart from '@/models/Cart';
import CartItem from '@/models/CartItem';

export default {

  props: ['editing'],

  data() {
    return {
      cartItem: new CartItem({ itemId: 0, type: 'giftcert', giftAmount: (PortalSettings.get('enableGiftCertDenom', false) ? PortalSettings.get('giftCertDenom', 0) : 0) })
    }
  },

  created(){
    this.resetCartItem();
  },

  computed: {
    enableCustomAmount() {
      return PortalSettings.get('enableGiftCertCustomAmount', false);
    },

    enableDenoms() {
      return PortalSettings.get('enableGiftCertDenom', false);
    },

    denoms() {
      let denom = PortalSettings.get('giftCertDenom', 1);
      let max = PortalSettings.get('giftCertMax', 0);
      let denoms = [];
      for (let i = denom; i <= max; i += denom) {
        denoms.push(i);
      }
      return denoms;
    },

    buttonActive() {
      let bookable = this.cartItem.giftAmount > 0 &&
                     this.cartItem.giftFirstName &&
                     this.cartItem.giftLastName &&
                     this.cartItem.giftEmail;

      return bookable;
    }
  },

  watch: {
    '$cart.active': function(newCart){
      if (newCart.items.length){
        this.resetCartItem();
      }
    }
  },

  methods: {
    resetCartItem() {
      if(this.editing && this.$cart.active.items.length){
        this.cartItem = this.$cart.active.items.find(item => {
          return item.id == this.editing;
        });
      }
    },

    onAddToCart() {
      Cart.add(this.cartItem).then(() => {
        this.cartItem = this.resetCartItem;
        // redirect to the cart TODO jamie handle errors
        this.$router.push({name: 'cart'});
      });
    }
  },

  components: {
    FormInput
  }
}
</script>

<style lang="scss">
.view.giftcert {

  .container {
    @include breakpoint(medium) {
      max-width: 510px;
      margin: auto;
      margin-top: 40px;
    }
  }

  .preset-amount {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 10px;
    margin-bottom: 25px;
    @include breakpoint(medium) {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    }
    /*  IE */
    @media all and (-ms-high-contrast:none) {
      @include clearfix;
      > div {
        width: 100px;
        float: left;
        margin-bottom: 5px;
        margin-right: 5px;
      }
    }

    .button-amount {
      &+label {
        @include button(#e9e9e9, $colorCTA);
        min-width: unset;
        text-align: center;
        width: 100%;
        padding: 0 10px;
        font-size: 15px;
        background: none;
        border: 1px solid $colorCTA;
        &::before {
          content: none;
        }
      }
      &:checked + label,
      &:hover + label {
        background-color: $colorCTA;
        color: #fff;
      }
    }
  }

  // show 2 inputs in 1 row
  .name-container {
    @include inputs-in-1row;
  }

  // form override style
  .component.form-input {
    @include form-layout-wide;
  }

  .amount .icon { @include font-awesome($fa-var-gift-card, light); }
  .name .icon { @include font-awesome($fa-var-smile, light); }
  .email .icon { @include font-awesome($fa-var-envelope, light); }
  .message .icon { @include font-awesome($fa-var-comment-dots, light); }

  .total-price {
    @include font-h2;
    @include form-border-top;
    text-align: right;
    margin-bottom: 20px;
    &::before {
      @include breakpoint(medium) {
        margin: 0 0 20px 0;
        width: 100%;
      }
    }

    span {
      margin-left: 10px;
    }
  }

  .button-add {
    @include inactive-button($colorCTA, #fff);
    width: 100%;
    margin-bottom: 10px;
    @include breakpoint(medium) {
      margin-bottom: 50px;
    }
  }
}
</style>